<template>
  <div class="container p-0" v-show="!hidden">
    <div class="input-group has-validation">
      <input :ref="'inputField_' + element.name" :value="value" @input="elementChanged" @blur="elementChanged" :type="element.type"
        :id="ids.input" :name="element.name" :autocomplete="element.autocomplete || 'on'" class="form-control"
        :placeholder="getTextFor(element.placeholder, lang)" :required="element.required" :aria-describedby="describedBy" :aria-invalid="ariaInvalid" :disabled="hidden">
    </div>
    <div class="invalid-feedback" :id="ids.error" :style="invalidStyle">{{ getTextFor(element.invalid, lang) }}</div>
    <div v-if="heeftUitleg" :id="ids.help" class="form-text">{{ getTextFor(element.explanation, lang) }}</div>
  </div>
</template>

<script>
import veldToegankelijkheid from '../../utils/veldToegankelijkheid'

export default {
  mixins: [veldToegankelijkheid],
  name: 'FormElementTextInput',
  props: ['element', 'lang', 'targetId', 'wasValidated', 'value', 'hidden'],
  emits: ['elementChanged'],
  methods: {
    elementChanged() {
      const inputValue = this.$refs['inputField_' + this.element.name].value;
      
      // Als het een datum-gerelateerd veld is, zet het terug naar ISO formaat voor opslag
      if (['date', 'datetime-local', 'time'].includes(this.element.type) && inputValue) {
        try {
          // Voor datetime-local en date, voeg de tijdzone info toe
          if (this.element.type === 'datetime-local' || this.element.type === 'date') {
            const date = new Date(inputValue);
            if (!isNaN(date.getTime())) {
              this.$emit('elementChanged', this.element.name, date.toISOString());
              return;
            }
          }
        } catch (error) {
          console.error('Error parsing date:', error);
        }
      }
      
      // Standaard gedrag voor niet-datum velden of bij fouten
      this.$emit('elementChanged', this.element.name, inputValue);
    },
    checkFieldValidity(fieldRef) {
      const field = this.$refs[fieldRef];
      return field && field.checkValidity();
    },
    getTextFor(data, lang) {
      return data ? data[lang] : '';
    }
  },

}
</script>
